const initialState = {
	accounted: [],
	unaccounted: [],
	procedureId: null,
	subscriptionChannel: null,
	isProcedureActive: false,
	procedureStartTime: null
};

const evacuationAccountability = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case "ACCOUNTED_CARDHOLDERS_RECEIVED": {
			const { id } = payload;
			return {
				...state,
				accounted: [...state.accounted.filter((p) => p.id !== id), payload],
				unaccounted: state.unaccounted.filter((p) => p.id !== id) // remove from other list
			};
		}

		case "UNACCOUNTED_CARDHOLDERS_RECEIVED": {
			const { id } = payload;
			return {
				...state,
				unaccounted: [...state.unaccounted.filter((p) => p.id !== id), payload],
				accounted: state.accounted.filter((p) => p.id !== id) // remove from other list
			};
		}

		case "PROCEDURE_INFO_RECEIVED":
			return {
				...state,
				...payload
			};

		case "RESET_EVACUATION":
			return {
				...initialState
			};

		default:
			return state;
	}
};

export default evacuationAccountability;
